import type { BaseModalProps } from '@byecode/ui'
import { DesktopModal, Modal } from '@byecode/ui'
import React from 'react'

import AliyunAccount from './AliyunAccount'

interface AliyunAccountModalProps extends BaseModalProps {}

export const AliyunCodeAccountModal: React.FunctionComponent<AliyunAccountModalProps> = ({ ...rest }) => {
    return (
        <DesktopModal
            width={676}
            {...rest}
            styles={{
                body: {
                    padding: '0!important'
                },
                header: {
                    borderStyle: 'none'
                }
            }}
        >
            <AliyunAccount onClose={rest.onClose} />
        </DesktopModal>
    )
}
